// extracted by mini-css-extract-plugin
module.exports = {"default":"SuperButton_default__FlHuv","red":"SuperButton_red__jtp3O"};